import { createAction } from 'redux-actions';
import * as ActionTypes from './ActionTypes';

export const setProject = createAction(ActionTypes.SET_PROJECT);
export const setLang = createAction(ActionTypes.SET_LANG);
export const setFrom = createAction(ActionTypes.SET_FROM);
export const setIsDev = createAction(ActionTypes.SET_IS_DEV);

const initialState = {
    projectId : '13',
    language : 'ko',
    from : 'other',
    isDev : false
}

function setting(state = initialState, action) {
    //console.info('[reducers.message.message][action]', action)
    switch(action.type) {
        case ActionTypes.SET_PROJECT:
            return {
                ...state,
                projectId : action.payload
            }
        case ActionTypes.SET_LANG:
            return {
                ...state,
                language : action.payload
            }
        case ActionTypes.SET_FROM:
            return {
                ...state,
                from : action.payload
            }
        case ActionTypes.SET_IS_DEV:
            return {
                ...state,
                isDev : action.payload
            }            
        default:
            return state;
    }
}

export default setting;